import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Modal, ModalBody, ModalFooter } from 'reactstrap';
import styled from 'styled-components';
import { setOrderCartState, setOrderId, setOrderType } from '../../actions/PrefOrder';
import '../../assets/css/locations.scss';
import CONSTANTS from '../../constants';
import OrderTypeHelper from '../../helpers/OrderTypeHelper';
import ViewHelper from '../../helpers/ViewHelper';
import CartService from '../../services/CartService';
import LoginService from '../../services/LoginService';
import QRCodeService from '../../services/QRCodeService';
import OrderTypeDetails from './OrderTypeDetails';

class PrefModal extends Component {

  constructor(props) {
    super(props);
    const current_time = new Date();
    let outlet = props?._outlets !== null && props?._outlets[0];
    const cartState = CartService.getOrderData(
      this.props.location?.orderTypes,
      this.props.location
    );
    let order_type = props?.location?.orderTypes.filter(
      (ot) => ot.order_type === cartState.order_type_id
    );
    if (order_type.length === 0) {
      order_type = props.location.orderTypes[0];
    } else {
      order_type = order_type[0];
    }
    const allowedOrderTypes = {};
    if (props._outlets !== null) {
      for (let i = 0; i < props._outlets.length; i++) {
        const out = props._outlets[i];
        for (let j = 0; j < out.orderTypes.length; j++) {
          allowedOrderTypes[out.orderTypes[j].order_type] = true;
          if (out.orderTypes[j].order_type === order_type.order_type) {
            if (outlet.loc_id === props.location.loc_id) continue;
            outlet = out;
          }
        }
      }
    }
    this.state = {
      allowedOrderTypes,
      isFirstLoad: true,
      cartState: {
        errors: [],
        showErrors: false,
        showMapModal: false,
        showTimePickerModal: false,
        showOutlets: false,
        showSavedLocations: false,
        current_time,
        delivery_phone: '',
        delivery_location: '',
        delivery_address: '',
        car_number: '',
        car_model: '',
        comment: '',
        order_type_id: order_type.id,
        order_time: current_time,
        order_date: CONSTANTS.ORDERS.VARIABLES.TIME_OPTIONS.TODAY,
        isPickUpNow: true,
        selectedOutlet: outlet,
        isTakeAwayAvail: false,
        selectedLocation: '',
        editLocation: '',
        itemIndex: '',
        showAlerModal: false,
        savedLocations: [],
        deliveryOutletError: false
      },
      order_type: order_type,
      order_type_id: order_type.id,
      order_id_changed: false
      // order_type_id: JSON.parse(localStorage.getItem('orderTypeId')) !== null ? JSON.parse(localStorage.getItem('orderTypeId')): order_type.id
    };
  }


  componentDidUpdate(prevprops) {
    const myElement =
      document?.getElementsByClassName('radio-tile-group')[0]?.children[0]?.firstChild;
    if (myElement && this.state.isFirstLoad) {
      myElement.click();
    }
    if (this.props.isLoggedIn !== prevprops.isLoggedIn) {
      const cartState = CartService.getOrderData(
        this.props.location.orderTypes,
        this.props.location
      );
      this.setState({ cartState });
    }
    if (this.props.location.loc_id !== prevprops.location.loc_id) {
      const cartState = CartService.getOrderData(
        this.props.location.orderTypes,
        this.props.location
      );
      this.setState({ cartState, order_type_id: cartState.order_type_id });
    }
    if (prevprops.showModal !== this.props.showModal) {
      const cartState = CartService.getOrderData(
        this.props.location.orderTypes,
        this.props.location
      );
      this.setState({ order_type_id: cartState.order_type_id });
    }
  }

  shouldComponentUpdate(nextProps) {
    if (
      this.props.showModal !== nextProps.showModal
    ) {
      const cartState = CartService.getOrderData(
        this.props.location.orderTypes,
        this.props.location
      );
      this.setState({ order_type_id: cartState.order_type_id });
      return false;
    }
    return true;
  }

  async componentDidMount() {
    let cartState = CartService.getOrderData(this.props.location.orderTypes, this.props.location);
    if (!cartState || !cartState.selectedOutlet) {
      cartState = this.state.cartState;
    }

    if (!cartState.order_type_id) {
      cartState.order_type_id = this.props.location.orderTypes[0].id;
    }
    let qrCode = QRCodeService.getQrCode();
    if (qrCode && qrCode.table_id !== '' && qrCode.status === 'true') {
      for (let i = 0; i < this.props.location.orderTypes.length; i++) {
        if (this.props.location.orderTypes[i].order_type === 'dine_in') {
          cartState.order_type_id = this.props.location.orderTypes[i].id;
        }
      }
    }
    await this.setState({ cartState, order_type_id: cartState.order_type_id });
    CartService.setOrderData(
      this.state.cartState,
      this.props.location.orderTypes,
      this.props.location
    );
    this.props.updateMenu(false, false);
  }

  onChange(event) {
    const target = event.target;
    this.setState({ [target.name]: parseInt(target.value) });
  }

  async changeOrderType(type) {
    const cartState = JSON.parse(JSON.stringify(this.state.cartState));
    cartState.order_type_id = type.id;
    localStorage.setItem('orderTypeId', JSON.stringify(cartState.order_type_id));
    await this.setState({
      order_type_id: type.id,
      order_type: type,
      cartState,
      order_id_changed: true,
      isFirstLoad: false
    });
  }


  updateState(cartState) {
    localStorage.setItem('orderTypeId', JSON.stringify(cartState.order_type_id));
    this.setState({ cartState });
  }

  getIconClassName(type, activity = false) {
    const root = document.documentElement;
    let primary_color = root.style.getPropertyValue('--highlight-color');
    if (activity === true) primary_color = 'var(--highlight-text-color)';

    if (type === 'dine_in') {
      return 'icon-dine_in';
    } else if (type === 'delivery') {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="17.733"
          height="13.975"
          viewBox="0 0 17.733 13.975"
        >
          <g id="ic-ecommerce-delivery" transform="translate(0.5 0.5)">
            <g id="Vrstva_535" data-name="Vrstva 535">
              <path
                id="Path_134"
                data-name="Path 134"
                d="M4.325,15.748H3.667A1.667,1.667,0,0,1,2,14.082V6.157A1.667,1.667,0,0,1,3.667,4.49h8.15a1.667,1.667,0,0,1,1.667,1.667v5.758"
                transform="translate(-2 -4.49)"
                fill="none"
                stroke={`${primary_color}`}
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1"
              />
              <path
                id="Path_135"
                data-name="Path 135"
                d="M15.75,8.19h2.317a.983.983,0,0,1,.775.375l1.883,2.5a1.508,1.508,0,0,1,.3.892v4.167a.167.167,0,0,1-.167.167H18.317"
                transform="translate(-4.292 -5.107)"
                fill="none"
                stroke={`${primary_color}`}
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1"
              />
              <circle
                id="Ellipse_29"
                data-name="Ellipse 29"
                cx="1.867"
                cy="1.867"
                r="1.867"
                transform="translate(10.225 9.242)"
                fill="none"
                stroke={`${primary_color}`}
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1"
              />
              <circle
                id="Ellipse_30"
                data-name="Ellipse 30"
                cx="1.867"
                cy="1.867"
                r="1.867"
                transform="translate(2.317 9.242)"
                fill="none"
                stroke={`${primary_color}`}
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1"
              />
              <line
                id="Line_121"
                data-name="Line 121"
                x1="4.275"
                transform="translate(5.958 11.217)"
                fill="none"
                stroke={`${primary_color}`}
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1"
              />
            </g>
          </g>
        </svg>
      );
    } else if (type === 'curbside_pickup') {
      return 'icon-curbside';
    } else if (type === 'pick_up') {
      return 'icon-pick_up';
    }
  }

  renderOrderTypeOptions(orderTypes) {
    return orderTypes
      .filter((ot) => this.state.allowedOrderTypes[ot.order_type])
      .map((orderType) => {
        if (this.props.location.layout === 'old') {
          return (
            <div key={orderType.id} className="input-container input-container-modal order-type">
              <input
                checked={orderType.id === this.state.order_type_id}
                value={orderType.id}
                id={orderType.order_type}
                className="radio-button"
                type="radio"
                name="order_type_id"
                onChange={() => { this.changeOrderType(orderType) }}
              />
              <div className="radio-tile modal-radio-tile">
                <label htmlFor={orderType.order_type} className="radio-tile-label">
                  {orderType.label}
                </label>
              </div>
            </div>
          );
        } else if (this.props.grid_layout !== 'old') {
          return (
            <div
              key={orderType.id}
              className={
                orderType.id === this.state.order_type_id
                  ? 'custom-order-pref-active custom-order-pref-radio-input-container input-container input-container-modal order-type'
                  : 'custom-order-pref-radio-input-container input-container input-container-modal order-type'
              }
            >
              <input
                checked={orderType.id === this.state.order_type_id}
                value={orderType.id}
                id={orderType.order_type}
                className="radio-button"
                type="radio"
                name={orderType.order_type}
                onChange={() => this.changeOrderType(orderType)}
              />
              <div className="radio-tile modal-radio-tile">
                {orderType.order_type === 'delivery' &&
                  this.getIconClassName(
                    'delivery',
                    orderType.id === this.state.order_type_id ? true : false
                  )}
                {orderType.order_type !== 'delivery' && (
                  <span
                    style={{ color: orderType.id === this.state.order_type_id && `#FFFFFF` }}
                    className={
                      orderType.id === this.state.order_type_id
                        ? `active-icon-class icon-class-value ${this.getIconClassName(
                          orderType.order_type,
                          true
                        )}`
                        : `${this.getIconClassName(orderType.order_type, false)} icon-class-value highlight-color`
                    }
                  ></span>
                )}
                <label
                  className={
                    orderType.id === this.state.order_type_id
                      ? 'radio-tile-title-active radio-tile-title'
                      : 'radio-tile-title'
                  }
                >
                  {orderType.label}
                </label>
              </div>
            </div>
          );
        }
        return '';
      });
  }

  submitPreferences() {
    const connection = window.navigator.onLine;
    if (connection) {
      this.updateCartData();
    } else {
      ViewHelper.showNetworkAlert(this.props.location.name);
    }
  }

  async updateCartData() {

    let orderData = CartService.getOrderData(this.props.location.orderTypes,
      this.props.location);
    let cartState = this.state.cartState;
    cartState.order_date = orderData.order_date;
    cartState.isPickUpNow = orderData.isPickUpNow;
    await this.setState({ cartState });
    if (this.state.cartState.order_type_id) {
      await this.setState({ order_type_id: this.state.cartState.order_type_id });
    }
    CartService.setOrderData(
      this.state.cartState,
      this.props.location.orderTypes,
      this.props.location
    );
    const items = CartService.getCart(this.props.location.loc_id);
    const discountedItems = items.map((i) => ({
      ...i,
      discounts: ViewHelper.getDiscountedItemPrice(
        i.menu_price,
        i.menu_id,
        i.menu_category_id,
        this.props.promotions,
        this.state.cartState.order_type_id,
        this.props.location.orderTypes
      )
    }));
    CartService.setCart(discountedItems);
    this.props.updateMenu(false, true, true);
  }

  isViewMenuEnabled() {
    if (!LoginService.getToken()) {
      return true;
    }
    if (this.state.cartState?.selectedOutlet) {
      const orderValidation = OrderTypeHelper.validateOrder(
        {
          ...this.state.cartState.selectedOutlet,
          orderTypes: this.props.location.orderTypes
        },
        this.state.cartState,
        false,
        false
      );
      let item = orderValidation.errors.some((row) => row.type === 'order_time');
      if (item) {
        let index = orderValidation.errors.findIndex(item => item.type === 'order_time');
        orderValidation.errors.splice(index, 1);
        orderValidation.enableSubmit = true
      }
      return orderValidation.enableSubmit;
    }
    return false;
  }

  render() {
    const { location: _location, _outlets } = this.props;
    const sortedTypes = OrderTypeHelper.sortOrderTypes(_location.orderTypes);
    if (_location && _outlets) {
      if (_location.layout === 'old') {
        return (
          <React.Fragment>
            <Modal
              isOpen={this.props.showModal}
              toggle={this.props.toggleModal}
              className="modal order-pref-modal"
            >
              {/* {closeBtn} */}
              <div className="modal-header no-border primary-color">
                <h5 className="modal-title fw-bolder primary-font-color">Order Preferences</h5>
                <Button
                  className="btn btn-primary btn-xs bg-transparent no-border primary-font-color"
                  onClick={() => { this.props.toggleModal() }}
                >
                  Skip
                </Button>
              </div>
              <ModalBody className="background-skin primary-color">
                <div className="card flex-md-row mb-2 box-shadow h-md-250 p-3 no-border card-color">
                  <div className="row row-width">
                    <div className="col-lg-12 order-types " id="order_type_id">
                      <div className="radio-container" id="minimum_order">
                        <div className="radio-tile-group">
                          {this.renderOrderTypeOptions(sortedTypes)}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <OrderTypeDetails
                  isLoggedIn={this.props.isLoggedIn}
                  toggleLoginModal={this.props.toggleLoginModal}
                  location={_location}
                  locationSettings={this.props.locationSettings}
                  cartState={this.state.cartState}
                  order_type_id={this.state.order_type_id}
                  geoLocation={this.props.geoLocation}
                  isDelivery={OrderTypeHelper.isDelivery(sortedTypes, this.state.order_type_id)}
                  outlets={OrderTypeHelper.pickOutletsFor(
                    sortedTypes,
                    this.state.order_type_id,
                    _outlets
                  )}
                  onChange={this.onChange.bind(this)}
                  updateState={this.updateState.bind(this)}
                />
              </ModalBody>
              <ModalFooter className="background-skin primary-color card-outline-color-hide">
                <div className="container-fluid">
                  <div className="row">
                    <Button
                      className={`col-lg-12 btn btn-primary btn-lg ${this.props.locationSettings.btn_outline_enable === 1 ? 'branding-btn-outline' : 'branding-btn'}`}
                      onClick={this.submitPreferences.bind(this)}
                    >
                      Done
                    </Button>
                  </div>
                </div>
              </ModalFooter>
            </Modal>
          </React.Fragment >
        );
      } else if (this.props.grid_layout !== 'old') {
        return (
          <React.Fragment>
            <StyledModal
              isOpen={this.props.showModal}
              toggle={this.props.toggleModal}
              className="modal custom-order-prev-modal order-pref-modal"
            >
              {/* {closeBtn} */}
              <div className="modal-header no-border primary-color">
                <h5 className="modal-title modal-font-weight primary-font-color">Order Preferences</h5>
                <Button
                  className="btn btn-primary btn-xs bg-transparent no-border primary-font-color"
                  onClick={() => { this.props.toggleModal() }}
                >
                  Skip
                </Button>
              </div>
              <ModalBody className="background-skin primary-color">
                <div className="card card-custom-header flex-md-row mb-2 box-shadow h-md-250 p-3 no-border card-color">
                  <div className="row row-width">
                    <div className="col-lg-12 order-types " id="order_type_id">
                      <div className="radio-container" id="minimum_order">
                        <div className="radio-tile-group">
                          {this.renderOrderTypeOptions(sortedTypes)}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <OrderTypeDetails
                  isLoggedIn={this.props.isLoggedIn}
                  toggleLoginModal={this.props.toggleLoginModal}
                  location={_location}
                  locationSettings={this.props.locationSettings}
                  cartState={this.state.cartState}
                  order_type_id={this.state.order_type_id}
                  geoLocation={this.props.geoLocation}
                  isDelivery={OrderTypeHelper.isDelivery(sortedTypes, this.state.order_type_id)}
                  outlets={OrderTypeHelper.pickOutletsFor(
                    sortedTypes,
                    this.state.order_type_id,
                    _outlets
                  )}
                  onChange={this.onChange.bind(this)}
                  updateState={this.updateState.bind(this)}
                />
              </ModalBody>
              <ModalFooter className="background-skin primary-color card-outline-color-hide">
                <div className="container-fluid">
                  <div className="row">
                    <Button
                      className={`col-lg-12 btn btn-primary btn-lg ${this.props.locationSettings.btn_outline_enable === 1 ? 'branding-btn-outline' : 'branding-btn'}`}
                      onClick={this.submitPreferences.bind(this)}
                    >
                      Done
                    </Button>
                  </div>
                </div>
              </ModalFooter>
            </StyledModal>
          </React.Fragment>
        );
      }
    } else {
      return null;
    }
  }
}

const StyledModal = styled(Modal)`
  max-width: 575px !important;

  .modal-header {
    padding:12px 30px 12px 20px !important;

    .modal-title {
      font-size: 20px;
       
      line-height: 23px;
      font-weight: 900 !important;
    }

    button {
      font-size: 14px;
      font-weight: 300 !important;
      padding-right: 0 !important;
    }
  }

  .card-custom {
    .order-types {
      padding-right: 5px !important;
      column-gap: 5px;

      .ps-3 {
        padding-left: 0 !important;
        padding-right: 0 !important;

        .time-field {
          margin: 0 !important;

          .text-bold {
            .type-title {
              font-size: 16px !important;
               
              font-weight: 500 !important;
              line-height: 20px !important;
              padding-left: 0 !important;

              svg {
                margin-right: 5px;
              }
            }
            margin-right: 5px;
          }

          small {
            .working-hour {
              font-size: 14px !important;
               
              font-weight: 300 !important;
              line-height: 18px !important;
              color: #2e2e2e;
              padding-left: 24px !important;
            }
          }

          .f3 {
            .ps-2 {
            }
          }
        }
      }
    }

    .ps-3 {
      padding: 0 20px;
    }
  }

  .card-custom-later {
    background: transparent;
    padding: 20px 10px !important;
    margin-top: 10px !important;
    margin-right: 20px !important;
    margin-left: 20px !important;

    .order-types {
      padding-right: 5px !important;

      .ps-3 {
        padding-left: 0 !important;
        padding-right: 0 !important;

        .time-field {
          margin: 0 !important;

          .text-bold {
            .type-title {
              font-size: 16px !important;
               
              font-weight: 500 !important;
              line-height: 20px !important;
              padding-left: 0 !important;

              svg {
                margin-right: 5px;
              }
            }
          }

          small {
            .working-hour {
              font-size: 14px !important;
               
              font-weight: 300 !important;
              line-height: 18px !important;
              color: #2e2e2e;
              padding-left: 24px !important;
            }
          }

          .f3 {
            .ps-2 {
            }
          }
        }
      }
    }
  }

  .active-card {
    border-radius: 10px !important;
    background: #ffffff;
    box-shadow: 0 3px 20px rgba(0, 0, 0, 0.06);
    //padding: 30px 20px !important;
    margin-top: 20px !important;
    margin-bottom: 20px !important;
    margin-right: 20px !important;
    margin-left: 20px !important;
  }

  .radio-tile-group {
    @media (min-width: 501px) {
      column-gap: 20px !important;
    }
    @media (max-width: 498px) {
      column-gap: 4px !important;
    }
    @media (max-width: 477px) {
      column-gap: unset !important;
    }
    @media (max-width: 426px) {
      column-gap: unset !important;
    }
  }

  .custom-order-pref-radio-input-container {
    width: 108px !important;
    margin: 0 !important;

    @media (max-width: 465px) {
      width: 100px !important;
    }
    @media (max-width: 443px) {
      width: 98px !important;
    }
    @media (max-width: 435px) {
      width: 90px !important;
    }
    @media (max-width: 426px) {
      width: 90px !important;
    }
    @media (max-width: 375px) {
      width: 80px !important;
    }
  }

  .custom-order-pref-active {
    width: 129px !important;
    height: 34px !important;
    @media (max-width: 498px) {
      width: 96px !important;
    }
  }

  .modal-radio-tile {
    display: flex !important;
    align-items: center !important;
    flex-direction: row !important;
    column-gap: 10px !important;
    padding: 8px 14px;
    transform: unset !important;
    @media (max-width: 498px) {
      column-gap: 4px !important;
    }

    .radio-tile-title {
      text-align: center;
      letter-spacing: 1px;
      font-size: 0.75rem;
      font-weight: 600;
      line-height: 16px;
      text-transform: uppercase;
      margin: 0;
      color: var(--highlight-color);

      @media (max-width: 498px) {
        font-size: 12px !important;
      }
    }

    .radio-tile-title-active {
      color: var(--highlight-text-color);
    }

    svg {
      min-width: 20px;
      min-height: 20px;
      width: 20px;
      height: 20px;

      @media (max-width: 426px) {
        min-width: 16px;
        min-height: 16px;
        width: 16px;
        height: 16px;
      }
      @media (max-width: 600px) {
        display: none;
      }
    }

    .icon-class-value {
      @media (max-width: 600px) {
        display: none;
      }
      &:before {
        font-size: 20px !important;

        @media (max-width: 426px) {
          font-size: 16px !important;
        }
      }
    }
  }

  .time-field {
    padding-left: 0 !important;
    padding-right: 0 !important;
    .text-bold {
      .ps-2 {
        // font-size: 16px;
        font-weight: 500;
         
        line-height: 20px;
      }
      margin-right: 5px;
    }
  }

  .order-time-title {
    padding-right: 20px !important;
    padding-left: 20px !important;

    .time-field {
      margin-bottom: 0 !important;
    }
  }

  .card-custom-header {
    margin-bottom: 20px !important;
    padding: 25px 20px 25px 20px !important;

    .order-types {
      padding-left: 0 !important;
      .text-bold {
        margin-right: 5px;
      }
      @media (max-width: 425px) {
        padding-left: 0 !important;
        .radio-tile-group {
          //justify-content: space-between;
        }
      }
      @media (max-width: 409px) {
        .radio-tile-group {
          justify-content: unset !important;
        }

        .custom-order-pref-radio-input-container {
          width: 89px !important;
        }
      }
      @media (max-width: 399px) {
        .custom-order-pref-radio-input-container {
          width: 87px !important;
        }
      }
      @media (max-width: 390px) {
        .custom-order-pref-radio-input-container {
          width: 86px !important;
        }
      }
      @media (max-width: 388px) {
        .custom-order-pref-radio-input-container {
          width: 87px !important;
        }
      }

      @media (max-width: 375px) {
        .custom-order-pref-radio-input-container {
          width: 80px !important;
          .modal-radio-tile {
            span {
              display: none;
            }

            svg {
              display: none;
            }
          }
        }
      }
      @media (max-width: 374px) {
        .custom-order-pref-radio-input-container {
          .modal-radio-tile {
            span {
              display: none;
            }

            svg {
              display: none;
            }
          }
        }
      }
    }
  }

  .modal-footer {
    padding-right: 15px;
    padding-left: 15px;
    padding-bottom: 20px;
  }

  .modal-body {
    .card-custom {
      margin-left: 20px;
      margin-right: 20px;
    }
  }
`;

function mapStateToProps(state) {
  const { location, childLocations, prefModalReducer } = state;
  return {
    _location: location,
    _outlets: childLocations,
    orderType: prefModalReducer.orderType,
    orderTypeId: prefModalReducer.orderTypeId
  };
}

export default connect(mapStateToProps, {
  setOrderId,
  setOrderType,
  setOrderCartState
})(PrefModal);